export enum ProgramConductorTypes {
    SHOW_PROGRAM_CONDUCTOR_LOADING = "SHOW_PROGRAM_CONDUCTOR_LOADING",
    HIDE_PROGRAM_CONDUCTOR_LOADING = "HIDE_PROGRAM_CONDUCTOR_LOADING",
    REQUEST_LOAD_PROGRAM_CONDUCTOR = "REQUEST_LOAD_PROGRAM_CONDUCTOR",
    SET_PROGRAM_CONDUCTOR_DATA = "SET_PROGRAM_CONDUCTOR_DATA",
    HIDE_PROMOTION = "HIDE_PROMOTION"
}